var _path, _path2, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBook(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFDD09"
    },
    d: "M92.867,41.667v426.667c0-18.773,12.8-34.133,29.867-34.133h294.4V7.533h-294.4 C105.667,7.533,92.867,22.893,92.867,41.667"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FD9808"
    },
    d: "M417.133,434.2h25.6V7.533h-25.6V434.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M92.867,41.667c0-18.773,12.8-34.133,29.867-34.133H101.4c-18.773,0-34.133,15.36-34.133,34.133 v426.667c0-16.213,11.093-29.013,25.6-33.28V41.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FCC309"
    },
    d: "M122.733,434.2c-17.067,0-29.867,15.36-29.867,34.133c0,18.773,12.8,34.133,29.867,34.133h294.4 V434.2H122.733z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M92.867,468.333c0-18.773,12.8-34.133,29.867-34.133H101.4c-18.773,0-34.133,15.36-34.133,34.133 c0,18.773,15.36,34.133,34.133,34.133h21.333C105.667,502.467,92.867,487.107,92.867,468.333"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FD9808"
    },
    d: "M417.133,502.467h25.6V434.2h-25.6V502.467z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#33A9F8"
    },
    d: "M135.533,331.8h238.933V195.267H135.533V331.8z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#54C9FD"
    },
    d: "M135.533,331.8h213.333V195.267H135.533V331.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#54C9FD"
    },
    d: "M212.333,118.467l-34.133-25.6l-34.133,25.6V7.533h68.267V118.467z"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M374.467,340.333H135.533c-5.12,0-8.533-3.413-8.533-8.533V195.267c0-5.12,3.413-8.533,8.533-8.533h238.933 c5.12,0,8.533,3.413,8.533,8.533V331.8C383,336.92,379.587,340.333,374.467,340.333z M144.067,323.267h221.867V203.8H144.067 V323.267z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M297.667,255h-85.333c-5.12,0-8.533-3.413-8.533-8.533c0-5.12,3.413-8.533,8.533-8.533h85.333 c5.12,0,8.533,3.413,8.533,8.533C306.2,251.587,302.787,255,297.667,255z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M323.267,289.133H186.733c-5.12,0-8.533-3.413-8.533-8.533c0-5.12,3.413-8.533,8.533-8.533h136.533 c5.12,0,8.533,3.413,8.533,8.533S328.387,289.133,323.267,289.133z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M212.333,127c-1.707,0-3.413-0.853-5.12-1.707L178.2,103.96l-29.013,21.333c-2.56,1.707-5.973,2.56-8.533,0.853 c-3.413-1.707-5.12-4.267-5.12-7.68V7.533c0-5.12,3.413-8.533,8.533-8.533h68.267c5.12,0,8.533,3.413,8.533,8.533v110.933 c0,3.413-1.707,5.973-5.12,7.68C214.893,127,214.04,127,212.333,127z M178.2,84.333c1.707,0,3.413,0.853,5.12,1.707l20.48,15.36 V16.067h-51.2V101.4l20.48-15.36C174.787,85.187,176.493,84.333,178.2,84.333z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M442.733,511H101.4c-23.893,0-42.667-18.773-42.667-42.667c0-23.893,18.773-42.667,42.667-42.667h341.333 c5.12,0,8.533,3.413,8.533,8.533v68.267C451.267,507.587,447.853,511,442.733,511z M101.4,442.733c-14.507,0-25.6,11.093-25.6,25.6 c0,14.507,11.093,25.6,25.6,25.6h332.8v-51.2H101.4z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M67.267,476.867c-5.12,0-8.533-3.413-8.533-8.533V41.667C58.733,17.773,77.507-1,101.4-1h341.333 c5.12,0,8.533,3.413,8.533,8.533V434.2c0,5.12-3.413,8.533-8.533,8.533H101.4c-14.507,0-25.6,11.093-25.6,25.6 C75.8,473.453,72.387,476.867,67.267,476.867z M101.4,16.067c-14.507,0-25.6,11.093-25.6,25.6V434.2 c6.827-5.12,16.213-8.533,25.6-8.533h332.8v-409.6H101.4z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M400.067,476.867H109.933c-5.12,0-8.533-3.413-8.533-8.533c0-5.12,3.413-8.533,8.533-8.533h290.133 c5.12,0,8.533,3.413,8.533,8.533C408.6,473.453,405.187,476.867,400.067,476.867z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBook);
export default __webpack_public_path__ + "static/media/book.137f262efd29c280523c483ee867f579.svg";
export { ForwardRef as ReactComponent };